import React from "react";
import hero from "../../images/hero.png";
import styled from "styled-components";
const ImageContainer = styled.div`
  max-width: 480px;
  max-height: 296px;
  object-fit: cover;
`;
const Container = styled.div`
  width: 95%;
  margin: 10px auto 20px auto;
`;

function Banner() {
  return (
    <Container>
      <ImageContainer>
        <img src={hero} alt="" width={"100%"} />
      </ImageContainer>
    </Container>
  );
}

export default Banner;
